import type { PlanInfo } from '../types';
import { t } from '../i18n';

export function planManagementUrl(planInfo: PlanInfo): string | null {
  return planInfo.manage_plan_url || planInfo.pricing_url;
}

export function canManagePlan(planInfo: PlanInfo): boolean {
  return (planInfo.can_manage_plan ?? Boolean(planInfo.pricing_url)) && Boolean(planManagementUrl(planInfo));
}

export function openPlanManagement(planInfo: PlanInfo): void {
  const url = planManagementUrl(planInfo);

  if (!canManagePlan(planInfo) || !url) {
    return;
  }

  window.open(url, '_top');
}

export function planManagementButtonLabel(): string {
  return t('manage_plan');
}
